import React from 'react'

const UpdateSvg = ({ needsUpdating, lastUpdated }) => {
  let fill = '#858485'
  let title = lastUpdated
  if (needsUpdating) {
    fill = '#3A86BF'
    title += ' - needs updating'
  }
  return (
    <svg
      width="18px"
      height="18px"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      enableBackground="new 0 0 1000 1000"
      version="1.1">
      <title>{title}</title>
      <defs />
      <g fill={fill}>
        <path d="M950.9,541.5c0,0-124.8,309.9-532.8,159.9l31.3-76.3c0,0,27.8-75-68.2-57l-269.6,71.7c0,0-61.2,18.4-32.7,72l154.4,262c0,0,46.7,42.8,76.2-10.4l30.9-76.6C340.5,886.6,845.4,1078.6,950.9,541.5z" />
        <path d="M49.1,441.3c0,0,132.4-306.7,536.6-146.5l-33.3,75.6c0,0-29.6,74.2,66.8,58.7l271.3-64.8c0,0,61.7-16.9,34.3-71.2L777.3,27.4c0,0-45.7-44.1-76.6,8.3l-32.8,75.9C667.9,111.6,168-92.9,49.1,441.3z" />
      </g>
    </svg>
  )
}

export default UpdateSvg
